export const checkSectionCondition = (value) => {
    let isWithoutAnswer;
    if (Array.isArray(value)) {
        isWithoutAnswer = value
            .map((val) => String(val || '').extensions.isEmpty())
            .reduce((accumulator, currentValue) => currentValue && accumulator, true);
        return !isWithoutAnswer;
    }
    isWithoutAnswer = String(value || '').extensions.isEmpty();
    return !isWithoutAnswer;
};

export default checkSectionCondition;